/** 新版 LLM API 聚合平台前端（llm.ibaicloud.com） */
export function getLlmFrontModelsUrl() {
  const raw = process.env.LLM_FRONT_URL || "https://llm.ibaicloud.com/";
  const base = String(raw).replace(/\/+$/, "");
  return `${base}/me/models`;
}

export function redirectToLlmFrontModels(replace) {
  const url = getLlmFrontModelsUrl();
  if (replace) {
    window.location.replace(url);
  } else {
    window.location.href = url;
  }
}

/** console 旧地址 #/ai_index → 新版聚合平台模型广场 */
export function isLegacyConsoleAiIndexRoute(to) {
  if (!to) return false;
  if (to.name === "ai_index") return true;
  const path = String(to.path || "").replace(/\/+$/, "") || "/";
  return path === "/ai_index";
}



// WEBPACK FOOTER //
// ./src/util/llmFrontUrl.js